import React from "react";

export default function ActionsBar({
  onSave,
  onCancel,
  saveLabel = "Save",
  saving = false,
  statePreview,
  showStatePreview = false,
}) {
  return (
    <div className="cn-actions">
      <button onClick={onCancel} disabled={saving}>
        Cancel
      </button>
      <button onClick={onSave} disabled={saving}>
        {saving ? "Saving…" : saveLabel}
      </button>
      {showStatePreview && statePreview && (
        <details style={{ marginLeft: 12 }}>
          <summary>State preview</summary>
          <pre>{JSON.stringify(statePreview, null, 2)}</pre>
        </details>
      )}
    </div>
  );
}
